import { data } from '../../svg/ChatBubble/data';
import { makeIcon } from '../makeIcon';

export const ChatBubble = makeIcon(data, 'chat_bubble', 'ChatBubble');

export default ChatBubble;
